const locale = {
  'c.ModifyPassword.title': '修改密码',

  'c.ModifyPassword.label.oldPassword': '原密码',
  'c.ModifyPassword.placeholder.oldPassword': '请输入原密码',

  'c.ModifyPassword.label.newPassword': '新密码',
  'c.ModifyPassword.placeholder.newPassword': '8-26位(需含大、小写字母和数字3种)',
  'c.ModifyPassword.rule.newPassword.min': '密码长度不能小于8位!',
  'c.ModifyPassword.rule.newPassword.repeat': '新密码不能与原密码相同!',

  'c.ModifyPassword.label.confirmPassword': '确认密码',
  'c.ModifyPassword.placeholder.confirmPassword': '再次确认新密码',
  'c.ModifyPassword.rule.confirmPassword.inconsistent': '两次密码输入不一致!',

  'c.ModifyPassword.button.submit': '保存',

  'c.ModifyPassword.request.loading': '修改密码中...',
  'c.ModifyPassword.request.success': '密码修改成功，请重新登录。',
  'c.ModifyPassword.request.error': '密码修改失败！请稍后重试。',
};
export default locale;
